import React, { useState } from 'react';
import type { Itinerary } from '../types/api';
import LegDetail from './LegDetail';
import { formatDuration, formatTime, formatDistance, modeIcon, getRouteLabel, getRouteBadgeColor } from '../utils/format';

interface ItineraryCardProps {
  itinerary: Itinerary;
  selected: boolean;
  onSelect: () => void;
}

export default function ItineraryCard({ itinerary, selected, onSelect }: ItineraryCardProps) {
  const [expanded, setExpanded] = useState(false);

  const transitLegs = itinerary.legs.filter((l) => l.transitLeg);
  const modeIcons = itinerary.legs.map((l, i) => (
    <span key={i} className="mode-badge">{modeIcon(l.mode)}</span>
  ));

  const routeLabels = transitLegs.map((l, i) => (
    <span key={i} className="route-label" style={{
      background: getRouteBadgeColor(l),
      color: 'white', padding: '1px 6px', borderRadius: 3, fontSize: 11, fontWeight: 600,
    }}>
      {getRouteLabel(l)}
    </span>
  ));

  return (
    <div
      className={`itinerary-card ${selected ? 'selected' : ''}`}
      onClick={() => { onSelect(); setExpanded(true); }}
    >
      <div className="itinerary-header">
        <span className="it-time">
          {formatTime(itinerary.startTime)} – {formatTime(itinerary.endTime)}
        </span>
        <span className="it-duration">{formatDuration(itinerary.duration)}</span>
        <span className="it-modes">{modeIcons}</span>
        <span className="it-transfers">
          {itinerary.numberOfTransfers === 0 ? 'Direct' : `${itinerary.numberOfTransfers} transfer${itinerary.numberOfTransfers > 1 ? 's' : ''}`}
        </span>
      </div>
      {routeLabels.length > 0 && (
        <div className="it-route-labels" style={{ display: 'flex', gap: 4, marginTop: 2, flexWrap: 'wrap' }}>
          {routeLabels}
        </div>
      )}
      <div className="itinerary-stats">
        {itinerary.bikeDistance > 0 && (
          <span className="stat">Bike: {formatDistance(itinerary.bikeDistance)}</span>
        )}
        {itinerary.walkDistance > 0 && itinerary.bikeDistance === 0 && (
          <span className="stat">Walk: {formatDistance(itinerary.walkDistance)}</span>
        )}
        {itinerary.transitTime > 0 && (
          <span className="stat">Transit: {formatDuration(itinerary.transitTime)}</span>
        )}
      </div>
      {expanded && (
        <div className="itinerary-legs">
          {itinerary.legs.map((leg, i) => (
            <LegDetail key={i} leg={leg} expanded={selected} />
          ))}
        </div>
      )}
    </div>
  );
}
